import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-final-report-form',
  templateUrl: './final-report-form.component.html',
  styleUrls: ['./final-report-form.component.css']
})
export class FinalReportFormComponent implements OnInit {

  title="Final Report";
  chargesheet1:boolean;
  evidence1:boolean ;
  undetected1:boolean ;
  transfer1:boolean ;
  Fir_id: any;
  Court_Proc_Id: any;
  CourtDocDetails: any = {};
  FirDetails: any = {};
  CourtProc: any = {};
  CourtDoc: any = {};
  fileToUpload: File = null;
  formSubmitted: boolean;
  formInvalid: boolean;
  data: any;
  F:any={};
  FinalReportId: any;
  c:any={}; 
  e:any={};   
  u:any={}; 
  t:any={}; 
  Eenable:any=0;
  Cenable:any=0;
  Uenable:any=0;
  Tenable:any=0;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.formSubmitted = false;
  
    this.chargesheet1=false;
    this.evidence1 = false;
    this.undetected1 = false;
    this.transfer1 = false;
  } 

  Chargesheet(){
    this.chargesheet1 = true;
    this.evidence1 = false;
    this.transfer1= false;
    this.undetected1 = false;
  }
  Evidence(){
    this.chargesheet1 = false;
    this.evidence1 = true;
    this.transfer1= false;
    this.undetected1 = false;
  }
  Undetected(){
    this.chargesheet1 = false;
    this.evidence1 = false;
    this.undetected1 = true;
    this.transfer1 = false;
  }
  Transfer(){
    this.chargesheet1 = false;
    this.evidence1 = false;
    this.undetected1 = false;
    this.transfer1 = true;
  }


 

  ngOnInit() {
    this.route.params.subscribe(params =>
      this.Fir_id= params['Fir_id'],
      
       
    );
    if (this.Fir_id != null)
      this.GetFirForTheIdF(this.Fir_id);
      // this.GetChargeSheetById(this.Fir_id);
     
  }

  GetFirForTheIdF(Fir_id) {
    debugger;
     
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetFirForTheIdF(Fir_id)
    
      .subscribe(
        (data: any) => {       
          this.FirDetails = data;      
          this.GetChargeSheetById(this.Fir_id)   
          this.GetEvidenceById(this.Fir_id);
          this.GetUndetectById(this.Fir_id)   
          this.GetTransferById(this.Fir_id);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
       
  }



  //getbyid for chargesheet1

  GetChargeSheetById(Fir_id){
    debugger
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.GetFirForTheIdForChargesheet(Fir_id);
        this.data.subscribe(
          (response: any) => {
            if(response!=null)
            this.c = response;
            if(response!=null)
            {
               this.Cenable=1;
            }             
            document.getElementById('loader-spinner').style.display = "none";
          },(error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401 || error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
  }
//getbyide for evidence
GetEvidenceById(Fir_id){
  debugger
  document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.GetFirForTheIdForEvidence(Fir_id);
      this.data.subscribe(
        (response: any) => {
          if(response!=null)
          this.e = response; 
          if(response!=null)
          {
             this.Eenable=1;
          }

          console.log(response);                   
          document.getElementById('loader-spinner').style.display = "none";
        },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401 || error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
}
//getbyide for undetect
GetUndetectById(Fir_id){
  debugger
  document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.GetFirForTheIdForUndetect(Fir_id);
      this.data.subscribe(
        (response: any) => {
          if(response!=null)
          this.u = response;
          if(response!=null)
            {
               this.Uenable=1;
            }                       
          document.getElementById('loader-spinner').style.display = "none";
        },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401 || error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
}

//getbyide for transfer
GetTransferById(Fir_id){
  debugger
  document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.GetFirForTheIdForTransfer(Fir_id);
      this.data.subscribe(
        (response: any) => {
          if(response!=null)
          this.t = response;
          if(response!=null)
            {
               this.Tenable=1;
            }                     
          document.getElementById('loader-spinner').style.display = "none";
        },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401 || error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
}
//upload1

imageUpload1(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage1c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('ChargeS_Offc_Upload');
       // i.value = "";
        if (error.status == 400) {         
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('ChargeS_Offc_Upload');
   // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}



getFeasibilityFirBriefFUrl1() {
  let imagename = null;
  try {
    imagename = document.getElementById('ChargeS_Offc_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//upload 2
imageUpload2(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage2c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('ChargeS_Doc_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('ChargeS_Doc_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}



getFeasibilityFirBriefFUrl2() {
  let imagename = null;
  try {
    imagename = document.getElementById('ChargeS_Doc_Upload');   
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//upload 3
imageUpload3(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage3c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('ChargeS_Court_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('ChargeS_Court_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}



getFeasibilityFirBriefFUrl3() {
  let imagename = null;
  try {
    imagename = document.getElementById('ChargeS_Court_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}
//upload 4
imageUpload4(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage4c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('ChargeS_Case_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('ChargeS_Case_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}



getFeasibilityFirBriefFUrl4() {
  let imagename = null;
  try {
    imagename = document.getElementById('ChargeS_Case_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//upload5
imageUpload5(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage5c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('ChargeS_Judge_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('ChargeS_Judge_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}



getFeasibilityFirBriefFUrl5() {
  let imagename = null;
  try {
    imagename = document.getElementById('ChargeS_Judge_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}
  //save for chargesgheet
  SaveChargeSheet(ChargeSheet:NgForm,Fir_id,FinalReportId) {    
    debugger;
    // ChargeSheet.value.FinalReportId = this.FinalReportId;
    console.log('ChargeSheet Forms');
    console.log(ChargeSheet.value);

    if (ChargeSheet.invalid) {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }

    else {
      console.log('Data');
      console.log(ChargeSheet.value);
      ChargeSheet.value.ChargeS_Offc_Upload = this.getFeasibilityFirBriefFUrl1();
      ChargeSheet.value.ChargeS_Doc_Upload = this.getFeasibilityFirBriefFUrl2();
      ChargeSheet.value.ChargeS_Court_Upload = this.getFeasibilityFirBriefFUrl3();
      ChargeSheet.value.ChargeS_Case_Upload = this.getFeasibilityFirBriefFUrl4();
      ChargeSheet.value.ChargeS_Judge_Upload = this.getFeasibilityFirBriefFUrl5();  
      this.data = this.userService.CreateChargeSheet(ChargeSheet.value,Fir_id,FinalReportId);
      this.data.subscribe(
        (response) => {
          ChargeSheet.reset();
          ChargeSheet.resetForm();
          ChargeSheet.form.markAsPristine();
          ChargeSheet.form.markAsUntouched();
          swal('Success!', 'ChargeSheet Added Successfully .', 'success');
          this.router.navigate(['/home/final-report']);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });

           }
  }


  // upload fro evidence
  //upload6
imageUpload6(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage5c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('Evidenc_Offc_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('Evidenc_Offc_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}
getFeasibilityFirBriefFUrl6() {
  let imagename = null;
  try {
    imagename = document.getElementById('Evidenc_Offc_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

//upload 7
imageUpload7(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage5c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('EvidencCourt_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('EvidencCourt_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


getFeasibilityFirBriefFUrl7() {
  let imagename = null;
  try {
    imagename = document.getElementById('EvidencCourt_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}
//upload 8
imageUpload8(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage5c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('Evidenc_Judge_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('Evidenc_Judge_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}
getFeasibilityFirBriefFUrl8() {
  let imagename = null;
  try {
    imagename = document.getElementById('Evidenc_Judge_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}
//save for evidence

SaveEvidence(Evidence:NgForm,Fir_id,FinalReportId) {    
  debugger;
  // ChargeSheet.value.FinalReportId = this.FinalReportId;
  console.log('ChargeSheet Forms');
  console.log(Evidence.value);

  if (Evidence.invalid) {
    this.formInvalid = true;
    swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    return;
  }

  else {
    console.log('Data');
    console.log(Evidence.value);
    Evidence.value.Evidenc_Offc_Upload = this.getFeasibilityFirBriefFUrl6();
    Evidence.value.EvidencCourt_Upload = this.getFeasibilityFirBriefFUrl7();
    Evidence.value.Evidenc_Judge_Upload = this.getFeasibilityFirBriefFUrl8();     
    this.data = this.userService.CreateEvidence(Evidence.value,Fir_id,FinalReportId);
    this.data.subscribe(
      (response) => {
        Evidence.reset();
        Evidence.resetForm();
        Evidence.form.markAsPristine();
        Evidence.form.markAsUntouched();
        swal('Success!', 'Evidence Added Successfully .', 'success');
        this.router.navigate(['/home/final-report']);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });

         }
}

// save for undetect
SaveUndetect(Undetect:NgForm,Fir_id,FinalReportId) {    
  debugger;
  // ChargeSheet.value.FinalReportId = this.FinalReportId;
  console.log('Undetect Forms');
  console.log(Undetect.value);

  if (Undetect.invalid) {
    this.formInvalid = true;
    swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    return;
  }

  else {
    console.log('Data');
    console.log(Undetect.value);
    Undetect.value.Undetect_Offc_Upload = this.getFeasibilityUndetectFUrl8();
    Undetect.value.UndetectCourt_Upload = this.getFeasibilityUndetectFUrl9();
    Undetect.value.Undetect_Judge_Upload = this.getFeasibilityUndetectFUrl10();     
    this.data = this.userService.CreateUndetect(Undetect.value,Fir_id,FinalReportId);
    this.data.subscribe(
      (response) => {
        Undetect.reset();
        Undetect.resetForm();
        Undetect.form.markAsPristine();
        Undetect.form.markAsUntouched();
        swal('Success!', 'Undetect Added Successfully .', 'success');
        this.router.navigate(['/home/final-report']);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });

         }
}

//upload for undetect
imageUpload9(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage5c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('Undetect_Offc_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('Undetect_Offc_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}
getFeasibilityUndetectFUrl8() {
  let imagename = null;
  try {
    imagename = document.getElementById('Undetect_Offc_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

imageUpload10(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage5c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('UndetectCourt_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('UndetectCourt_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}
getFeasibilityUndetectFUrl9() {
  let imagename = null;
  try {
    imagename = document.getElementById('UndetectCourt_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}Undetect_Judge_Upload
imageUpload11(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage5c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('Undetect_Judge_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('Undetect_Judge_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}
getFeasibilityUndetectFUrl10() {
  let imagename = null;
  try {
    imagename = document.getElementById('Undetect_Judge_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}


//create for Transfer

SaveTransfer(Transfer:NgForm,Fir_id,FinalReportId) {    
  debugger;
  // ChargeSheet.value.FinalReportId = this.FinalReportId;
  console.log('Transfer Forms');
  console.log(Transfer.value);

  if (Transfer.invalid) {
    this.formInvalid = true;
    swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    return;
  }

  else {
    console.log('Data');
    console.log(Transfer.value);
    Transfer.value.Trnsfr_Offc_Upload = this.getFeasibilityTransferFUrs1();
    Transfer.value.TrnsfrCourt_Upload = this.getFeasibilityTransferFUrs2();
    Transfer.value.Trnsfr_Judge_Upload = this.getFeasibilityTransferFUrs3();     
    this.data = this.userService.CreateTransfer(Transfer.value,Fir_id,FinalReportId);
    this.data.subscribe(
      (response) => {
        Transfer.reset();
        Transfer.resetForm();
        Transfer.form.markAsPristine();
        Transfer.form.markAsUntouched();
        swal('Success!', 'Transfer Added Successfully .', 'success');
        this.router.navigate(['/home/final-report']);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });

         }
}

//upload for undetect
imageUploads1(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage5c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('Trnsfr_Offc_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('Trnsfr_Offc_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}
getFeasibilityTransferFUrs1() {
  let imagename = null;
  try {
    imagename = document.getElementById('Trnsfr_Offc_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}

imageUploads2(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage5c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('TrnsfrCourt_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('TrnsfrCourt_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}


Cancel() {

  this.c.ChargeS_Off_Permission = '';
  this.c.ChargeS_Offc_Date = '';
  this.c.ChargeS_Offc_Upload = '';
  this.c.ChargeS_Doc_Name = '';
  this.c.Comp_Passport_no = '';
  this.c.ChargeS_Doc_date = '';
  this.c.ChargeS_Doc_Upload = '';
  this.c.ChargeS_Doc_Note = '';
  this.c.ChargeS_Court_Copy = '';
  this.c.ChargeS_Court_Date = '';
  this.c.ChargeS_Court_Upload = '';
  this.c.ChargeS_Court_Note = '';
  this.c.ChargeS_Case_No = '';
  this.c.ChargeS_Case_Date = '';
  this.c.ChargeS_Case_Upload = '';
  this.c.ChargeS_Case_Note = '';
  this.c.ChargeS_Judg_Date = '';
  this.c.ChargeS_Judge_Upload = '';
  this.c.ChargeS_Judge_Status = '';
  this.c.ChargeS_Judge_Desctpn = '';
  // this.c.Comp_DocPath = '';
  // this.c.Comp_CT_Id_Fk = '';
}
 Cancel2()
 {

  this.e.Evidenc_Off_Permission = '';
  this.e.Evidenc_Offc_Date = '';
  this.e.Evidenc_Offc_Upload = '';
  this.e.Evidenc_Court_Copy = '';
  this.e.Evidenc_Court_Date = '';
  this.e.EvidencCourt_Upload = '';
  this.e.Evidenc_Court_Note = '';
  this.e.Evidenc_Judg_Date = '';
  this.e.Evidenc_Judge_Upload = '';
  this.e.Evidenc_Judgement = '';
  this.e.Evidenc_Judge_Desctpn = '';
  this.e.Evidenc_Offc_Note = '';
  
 }

 Cancel3()
   {
    this.u.Undetect_Off_Permission = '';
    this.u.Undetect_Offc_Date = '';
    this.u.Undetect_Offc_Upload = '';
    this.u.Undetect_Court_Copy = '';
    this.u.Undetect_Court_Date = '';
    this.u.UndetectCourt_Upload = '';
     this.u.Undetect_Court_Note = '';
    this.u.Undetect_Judg_Date = '';
    this.u.Undetect_Judge_Upload = '';
    this.u.Undetect_Judgement = '';
    this.u.Undetect_Judge_Desctpn = '';
    this.u.Undetect_offc_Note = '';
    
   }
   Cancel4()
   {
    this.t.Trnsfr_Off_Permission = '';
    this.t.Trnsfr_Offc_Date = '';
    this.t.Trnsfr_Offc_Upload = '';
    this.t.Trnsfr_offc_Note = '';
    this.t.Trnsfr_Court_Copy = '';
    this.t.Trnsfr_Court_Date = '';
    this.t.TrnsfrCourt_Upload = '';
    this.t.Trnsfr_Court_Note = '';
    this.t.Trnsfr_Judg_Date = '';
    this.t.Trnsfr_Judge_Upload = '';
    this.t.Trnsfr_Judgement = '';
    this.t.Trnsfr_Judge_Desctpn = '';
   
   }


getFeasibilityTransferFUrs2() {
  let imagename = null;
  try {
    imagename = document.getElementById('TrnsfrCourt_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}
imageUploads3(file: FileList) {
  debugger;
  let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

  let s: any = file.item(0).size / 1024;
  let size: any = parseFloat(s).toFixed(2);
  let uploadedFilename = file.item(0).name;
  if (uploadedFilename.match(regex) && (size <= 5048)) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      //  this.IS_UploadPath = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
    const data = new FormData();
    data.append("UploadedImage", file.item(0));
    let x = this.userService.uploadImage5c(data);
    x.subscribe(
      (response) => {

      }, (error) => {
        let i: any = document.getElementById('Trnsfr_Judge_Upload');
        // i.value = "";
        if (error.status == 400) {
          //this.FeasibilityPDFUrl = "assets/images/image-default.png";
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  else {
    let i: any = document.getElementById('Trnsfr_Judge_Upload');
    // i.value = "";
    if (!uploadedFilename.match(regex))
      swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
    else if (size > 2048)
      swal('Warning!', "Please upload image file less than 2mb", 'warning');
  }
}
getFeasibilityTransferFUrs3() {
  let imagename = null;
  try {
    imagename = document.getElementById('Trnsfr_Judge_Upload');
    console.log('Fir file');
    console.log(imagename.files[0].name);
    return imagename.files[0].name;
  }
  catch (e) {
    return null;
  }
}
}



// WEBPACK FOOTER //
// ./src/app/final-reports/final-report/final-report-form/final-report-form.component.ts